import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { WidgetsBlock } from '@modules/layout/moleculas';
import { DashboardWidgetCount } from '@modules/dashboard/organisms';
import {
    useSummaryFiltersQuery,
    useSummaryLapsCoursesResults,
} from '@modules/summary-results/hooks';
import { SummaryResultsFilterRequest } from '@modules/summary-results/requests';

const Root = styled(WidgetsBlock)`
    & > div:last-child {
        grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    }
`;

const Empty = styled.div`
    width: 100%;

    > p {
        margin-top: 4px;
        font-size: 1.4rem;
    }
`;

const SummaryCoursesWidgets = (): React.ReactElement => {
    const { t } = useTranslation(['common', 'summary']);

    const { filters } = useSummaryFiltersQuery();
    const filter = new SummaryResultsFilterRequest(filters);

    const { courses, coursesCount, loading } = useSummaryLapsCoursesResults({
        fetchPolicy: 'network-only',
        variables: { filter },
    });

    const hasCoursesResults = coursesCount > 0;

    return (
        <Root title={t('summary:ready_courses')}>
            {hasCoursesResults && !loading ? (
                courses.map(programsResult => (
                    <DashboardWidgetCount
                        key={programsResult.courseName}
                        label={programsResult.courseName}
                        count={programsResult.count}
                        loading={loading}
                    />
                ))
            ) : (
                <Empty>
                    <p>{t('common:stubs.empty')}</p>
                </Empty>
            )}
        </Root>
    );
};

export { SummaryCoursesWidgets };
